<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="modalAberto" :title="title" @abort="cancelar"
        @hidden="cancelar">
        <b-form @submit.prevent="save">
            <b-card>
                <b-spinner v-if="busy" label="Carregando..." class="my-3 d-block mx-auto"></b-spinner>

                <b-container v-if="!busy" fluid>
                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um nome válido!" description=" "
                                :error="$v.form.nome" v-model="form.nome" label="Nome:*" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input :type="'email'" invalidFeedback="Informe um e-mail válido!" description=" "
                                :error="$v.form.email" v-model="form.email" :label="usarSIAPI ? 'Email:*' : 'Email:'" />
                        </b-col>
                    </b-row>


                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input v-if="!usarSIAPI" invalidFeedback="Informe um CPF válido!" description=" "
                                :error="$v.form.cpf" v-model="form.cpf" label="CPF:*" />

                            <lg-form-input v-if="usarSIAPI" invalidFeedback="Informe um SIAPI válido!" description=" "
                                :error="$v.form.siapi" v-model="form.siapi" label="SIAPI:*" />

                        </b-col>
                    </b-row>

                    <lg-finder-page-departamento-sgu :disabled="usarSIAPI && id" v-if="this.usarSIAPI" class="ml-2 mr-2"
                        :prefix="prefix + titlePage + ' > '" id="finderUnidadeAdministrativaUsuarioForm"
                        @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamentoSGU"
                        invalidFeedback="Informe uma unidade administrativa!" label="Unidade Administrativa:*"
                        :error="$v.form.departamentoSGU.id">
                    </lg-finder-page-departamento-sgu>


                    <b-row class="justify-content-center" v-if="id">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback=" " disabled description=" " v-model="form.usuario.login"
                                label="Usuário:" />
                        </b-col>
                    </b-row>


                    <b-row class="justify-content-center" v-if="id">
                        <b-col cols="12" sm="12">
                            <lg-form-input disabled invalidFeedback=" " description=" " v-model="form.usuario.matricula"
                                label="Matrícula:" />
                        </b-col>
                    </b-row>


                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um RG válido!" description=" " :error="$v.form.rg"
                                v-model="form.rg" label="RG:" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um Órgão Emissor válido!" description=" "
                                :error="$v.form.orgaoRg" v-model="form.orgaoRg" label="Órgão emissor:" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe uma UF válida!" description=" "
                                :error="$v.form.ufRg" v-model="form.ufRg" label="UF:" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="12">
                            <lg-form-input invalidFeedback="Informe um passaporte válido!" description=" "
                                :error="$v.form.passaporte" v-model="form.passaporte" label="Passaporte:" />
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center text-center">
                        <b-col cols="12">

                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" type="submit">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>

                        </b-col>
                    </b-row>
                </b-container>
            </b-card>
        </b-form>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import { required } from "vuelidate/lib/validators"
import ConfiguracaoSistemaEnum from "@/core/utils/ConfiguracaoSistemaEnum"
import LgFinderPageDepartamentoSgu from "@/components/Finders/LgFinderPageDepartamentoSgu.vue";

export default {
    components: {
        LgFormInput,
        LgFinderPageDepartamentoSgu
    },
    mixins: [FormResourceMixin],
    props: {
        id: Number,
        prefix: Array,
        showModal: {
            type: Boolean,
            default: true,
        },
    },
    validations() {
        return {
            form: {

                departamentoSGU: this.usarSIAPI ? { id: { required } } : {},
                nome: { required },
                cpf: this.usarSIAPI ? {} : { required },
                email: this.usarSIAPI ? { required } : {},
                siapi: this.usarSIAPI ? { required } : {}
            }
        }
    },
    data() {
        return {
            usarSIAPI: false,
            busy: true,
            extensoesPermitidas: '',
            modalAberto: true,
            titlePage: "Cadastro",
            form: {
                departamento: null,
                departamentoSGU: {},
                usuario: {},
                id: null,
                nome: "",
                cpf: "",
                siapi: "",
                email: "",
                rg: "",
                orgaoRg: "",
                ufRg: "",
                passaporte: "",
            },
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/pessoa`);
        var { data } = await new ResourceService(`/api/configuracoes-sistema`).get(ConfiguracaoSistemaEnum.CONFIG_EMAIL_EXTENSOES_PERMITIDAS.codConfiguracaoSistema);
        this.extensoesPermitidas = data.valorPropriedade;
        this.titlePage = this.title

        if (this.id) {
            const { data } = await this.$service.findById(this.id)

            if (!data.usuario)
                data.usuario = {};
            this.form = data
        }

        this.carregarSIAPI();

    },

    methods: {
        handleSelectUnidadeAdministrativa(departamento) {
            if (departamento && departamento.id) {
                this.form.departamentoSGU = departamento;
                this.form.departamento = departamento.id;
            }
            else {
                this.form.departamentoSGU = {};
                this.form.departamento = null;
            }
        },
        async carregarSIAPI() {
            var { data } = await new ResourceService("/api/configuracoes-sistema").get(ConfiguracaoSistemaEnum.UTILIZAR_SIAPI_CADASTRO_PESSOA.codConfiguracaoSistema);

            if (data.valorPropriedade == null || data.valorPropriedade == "" || data.valorPropriedade == '0') {
                this.usarSIAPI = false;
            }
            else {
                this.usarSIAPI = true;
            }
            this.busy = false;
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }


            if (this.form.email != null && this.form.email != "" &&
                this.extensoesPermitidas &&
                this.extensoesPermitidas != "" &&
                !(this.extensoesPermitidas.split(';').some(sufixo => this.form.email.endsWith(sufixo)))) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Extensão de email não permitida",
                });
                return;
            }


            try {
                await this.$saveResource(this.form, "", false, {}, false, true);
                this.$emit("close")

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }

        },

        cancelar() {
            this.modalAberto = false
            this.$emit("close")
        },

        resetForm() {
            this.form = {
                nome: "",
                cpf: "",
                rg: "",
                email: "",
                orgaoRg: "",
                ufRg: "",
                passaporte: "",
            }
        },
    },
}
</script>
